import {Component} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {SubFormComponent} from '../../_subform';

/*
* Блок общих данных специалиста
* */

@Component({
    providers: [
    ],
    selector: 'specialist-form-fields-common',
    templateUrl: './specialist-form-fields-common.component.html'
})
export class SpecialistFormFieldsCommonComponent extends SubFormComponent {
    public nameTitle = 'ФИО';

    public formGroupTemplate = this._fb.group({
        // Личные данные
        id: [''],
        lastname: [''], // Фамилия
        name: [''], // Имя
        middle_name: [''], // Отчество
        without_middle_name: [false], // Без отчества
        full_name_genitive: [''], // ФИО в родительном падеже
        full_name_dative: [''], // ФИО в дательном падеже
        birthday: [''], // Дата рождения
        INN: [''], // Инн
        photo_path: this._fb.group({ // Фотография
            file_id: [''],
            file_url: ['']
        }),
    });

    constructor(private _fb: FormBuilder) {
        super();
    }

    afterInit() {
        this.subs.push(
            this.form.get('without_middle_name').valueChanges.subscribe((val: boolean) => {
                /**
                 * Поскольку у нас backend валидация для этой формы, просто сбрасываем валидацию поля с отчеством, если
                 * выбрано "Без отчества".
                 */
                if (val) {
                    this.form.get('middle_name').markAsTouched();
                    this.form.get('middle_name').markAsDirty();
                    this.form.get('middle_name').updateValueAndValidity();
                    this.nameTitle = 'ФИ';
                } else {
                    this.nameTitle = 'ФИО';
                }
            })
        );

        this.nameTitle = this.form.get('without_middle_name').value ? 'ФИ' : 'ФИО';
    }
}
